// extracted by mini-css-extract-plugin
export var thumb = "Grid-module--thumb--8kMfG";
export var wrapper = "Grid-module--wrapper--wSSGt";